import { enterpriseLogsEnvironment } from '../enterprise-logs-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { copilotRequestSchema } from '../schemas/copilot-request.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Requests CoPilot Logs in a non-paginated format
 * @param accountId Account ID
 * @param deviceId Device ID
 * @param operation Specific operation you are requesting, null if none
 * @param onRoadEventType Specific onRoadEventType you are requesting, null if none
 * @param startTimestamp Start date/time of request
 * @param endTimestamp End date/time of request
 * @returns An array of the requested logs
 */
export function getLogSearch(
  this: unknown,
  accountId: string,
  deviceId: string,
  operation: string | null,
  onRoadEventType: string | null,
  startTimestamp: Date,
  endTimestamp: Date
) {
  const queryParams = {
    deviceId,
    startTimestamp: startTimestamp.toJSON(),
    endTimestamp: endTimestamp.toJSON(),
  };

  if (operation !== null) {
    Object.assign(queryParams, { operation });
  }

  if (onRoadEventType !== null) {
    Object.assign(queryParams, { onRoadEventType });
  }

  const query = Object.entries(queryParams)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  const url = `${enterpriseLogsEnvironment
    .resolve(this)
    .logSearchUrl(accountId)}?${query}`;

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(url, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(z.array(copilotRequestSchema)));
}
